<template>
    <Dialog
        class="custom-responsive-dialog"
        v-model:visible="visible"
        modal
        :header="props.title"
        :style="{ width: props.size, paddingBottom: '1rem' }"
        :draggable="false"
        :dismissableMask="!buttonClose"
        :closeOnEscape="!buttonClose"
    >
        <div class="pt-4">
            <slot name="content"></slot>
        </div>

        <div class="flex justify-end gap-2 pt-4">
            <Button type="button" label="Cancel" @click="onDialogClose" severity="secondary"></Button>
            <Button
                v-if="props.okLabel"
                type="button"
                :label="props.okLabel"
                :loading="props.loading"
                :disabled="props.okDisabled || props.loading"
                @click="onSaveClick()"
            ></Button>
            <slot name="okButton"></slot>
        </div>
    </Dialog>
</template>

<script setup>
import Dialog from "primevue/dialog";
import { Button } from "primevue";
import { DialogSize } from "../../core/enums/DialogSizeEnum";

import { defineProps, computed, defineEmits, defineModel } from "vue";

const emit = defineEmits(["onCreation"]);

const visible = defineModel("visible");

const props = defineProps({
    saveAction: {
        type: Function,
    },
    closeAction: {
        type: Function,
        default: () => {},
    },
    okLabel: {
        type: String,
    },
    okDisabled: {
        type: Boolean,
        default: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default: " ",
    },
    buttonClose: {
        type: Boolean,
        default: true,
    },
    size: {
        default: DialogSize.medium,
    },
});

const onSaveClick = () => {
    props.saveAction();
};

const onDialogClose = () => {
    props.closeAction();
    emit("update:visible", false);
};
</script>

<style lang="css">
@media (width <= 40rem) {
    .custom-responsive-dialog {
        width: 100vw !important;
        height: 100vh !important;
        max-height: 100% !important;
        border-radius: unset !important;
    }
}

.p-dialog-content {
    height: 100%;
}
</style>
